export default "__VITE_ASSET__DMHTeOIF__"